import moment from "./utils/moment" // 日期工具
import validate from "./utils/validate" // 表单校验
import decimal from "./utils/decimal" // 精确数字
import { messageUtil } from "./utils/tip" // 消息提示
import format from "./utils/format" // 格式转换工具
import Request from "./utils/request" // 接口封装
import utils from "./utils/index"
import auth from "./utils/auth"

export const Auth = auth
export const getToken = auth.getToken
export const setToken = auth.setToken
export const removeToken = auth.removeToken
export const getRefreshToken = auth.getRefreshToken
export const setRefreshToken = auth.setRefreshToken
export const removeRefreshToken = auth.removeRefreshToken
export const getSessionId = auth.getSessionId
export const setSessionId = auth.setSessionId
export const removeSessionId = auth.removeSessionId

export const week = moment.week
export const time = moment.time
export const weekCount = moment.weekCount
export const timeInterval = moment.timeInterval
export const Moment = moment

export const isExternal = validate.isExternal
export const isString = validate.isString
export const isArray = validate.isArray
export const validURL = validate.validURL
export const validLowerCase = validate.validLowerCase
export const validUpperCase = validate.validUpperCase
export const validAlphabets = validate.validAlphabets
export const validEmail = validate.validEmail
export const validMobile = validate.validMobile
export const validPhone = validate.validPhone
export const validIdCard = validate.validIdCard
export const isUndeFinedOrNullOrBlank = validate.isUndeFinedOrNullOrBlank
export const isJson = validate.isJson
export const isDot = validate.isDot
export const validPassword = validate.validPassword
export const Validate = validate

export const add = decimal.add
export const sub = decimal.sub
export const mul = decimal.mul
export const div = decimal.div
export const Decimal = decimal

export const getQueryObject = format.getQueryObject
export const byteLength = format.byteLength
export const cleanArray = format.cleanArray
export const param = format.param
export const param2Obj = format.param2Obj
export const html2Text = format.html2Text
export const objectMerge = format.objectMerge
export const getTime = format.getTime
export const debounce = format.debounce
export const deepClone = format.deepClone
export const uniqueArr = format.uniqueArr
export const createUniqueString = format.createUniqueString
export const toggleClass = format.toggleClass
export const hasClass = format.hasClass
export const addClass = format.addClass
export const removeClass = format.removeClass
export const digitalConversion = format.digitalConversion
export const formatPrice = format.formatPrice
export const formatThousandthSign = format.formatThousandthSign
export const toNum = format.toNum
export const toFixNum = format.toFixNum
export const toPercent = format.toPercent
export const toPoint = format.toPoint
export const hidePhoneNum = format.hidePhoneNum
export const trimLeft = format.trimLeft
export const trimRight = format.trimRight
export const trimSide = format.trimSide
export const trimAll = format.trimAll
export const arrayInsert = format.arrayInsert
export const arrDeepCopy = format.arrDeepCopy
export const accDiv = format.accDiv
export const accMul = format.accMul
export const accAdd = format.accAdd
export const accSubtr = format.accSubtr
export const swapArray = format.swapArray
export const filterObj = format.filterObj
export const getCnDitc = format.getCnDitc
export const keepDecimalPlaces = format.keepDecimalPlaces
export const toPercentage = format.toPercentage
export const toThousandthSign = format.toThousandthSign
export const toDecimalPlaces = format.toDecimalPlaces
export const Format = format

export const MessageUtil = messageUtil
export const request = Request
export const Utils = utils

export default {
  ...moment,
  ...Validate,
  ...Decimal,
  ...Format,
  ...auth,
  request,
  MessageUtil
}
